runOnLoad "SubscriberImports", ["edit_import_start", "update_import_start"], ->
  SchedulableForm.setup "subscriber_import"

runOnLoad "SubscriberImports", [ "edit_field_associations", "update_field_associations" ], ->

  # There's an "Add custom field" button on the edit field associations page.
  # Here we will enable that functionality.

  # Get fields we need below.
  $addThisCustomField = $("#add_custom_field_button")
  $customFieldList    = $("#add_custom_field_list")

  # Get the field currently selected.
  getCurrentFieldSection = ->
    customFieldId = $customFieldList.val()
    $customFieldSection = $(".custom_field_id-#{customFieldId}")
    return $customFieldSection

  # Respond to the add/remove button.
  $addThisCustomField.on "click", ->
    $customFieldSection = getCurrentFieldSection()
    if $customFieldSection.is(":visible")
      # The field is visible, so we disable it.
      $("input,select,textarea", $customFieldSection).attr("disabled", "disabled")
      $customFieldSection.hide()
    else
      # The field is hidden, so we enable it.
      $("input,select,textarea,[disabled=disabled]", $customFieldSection).removeAttr("disabled")
      $customFieldSection.show()
    adjustFieldInsertButton()
    return false

  # Adjust the text on the button based on whether the custom field is current visible.
  adjustFieldInsertButton = ->
    $customFieldSection = getCurrentFieldSection()
    action = if $customFieldSection.is(":visible") then "remove" else "add"
    $addThisCustomField.html(t "buttons.#{action}_this_custom_field")
  $customFieldList.on("change", adjustFieldInsertButton)
  adjustFieldInsertButton()

  # Show a warning if we're mapping "status".
  adjustStatusMappedWarning = ->
    $field = $(@)
    $warning = $field.closest(".import-map-selects").find(".import-map-warning span")
    if $field.val() == "status"
      $warning.html(t("notices.status_import_overrides_import_setting_html")).show()
    else
      $warning.hide()
  $(".import-map-selects select").on("change", adjustStatusMappedWarning).each(adjustStatusMappedWarning)

runOnLoad "SubscriberImports", ["new", "create"], ->
  FileUploadSelection.setup "subscriber_import"
